import { ForwardPlayer } from "./physics/players/ForwardPlayer";
import { GameVars } from "./GameVars";
import { Ball } from "./physics/Ball";
import { GameConstants } from "./GameConstants";
import { GameManager } from "./GameManager";
import { PenaltyFootballFieldState } from "./scenes/penalty-scene/PenaltyFootBallFieldState";

    export class PenaltyManager {

        public static currentInstance: PenaltyManager;

        private static isBallAttachedToShootingPlayer: boolean;
        private static forward: ForwardPlayer;
        private static game: Phaser.Game;

        public static init(game: Phaser.Game, forward: ForwardPlayer ): void {

            PenaltyManager.currentInstance = this;

            PenaltyManager.game = game;

            GameVars.matchEnded = false;
            GameVars.goalKeeperType = "normal";
            GameVars.penaltyScored = false;
            GameVars.isTimedLevel = false;
            GameVars.isGoalKeeperDuck = false;

            GameVars.isBallAttachedToPlayer = true;
            GameVars.paused = true;
            GameVars.penalties = true;

            PenaltyManager.forward = forward;

            // esto queda un poco confuso pq gamevars ya lo sabe
            PenaltyManager.isBallAttachedToShootingPlayer = true;

            // pegar una pelota al delantero
            // esto es un poco chapucilla
            let ball = new Ball(PenaltyManager.game, 0, 0);

            PenaltyManager.forward.ball = ball;
            ball.x = forward.shootBall_px;
            ball.y = forward.shootBall_py;
            forward.addChild(ball);
            forward.prepareToShoot();
        }

        public static onClickInGameScene(): void {

            if (this.isBallAttachedToShootingPlayer) {
                GameVars.isBallAttachedToPlayer = false;
                this.isBallAttachedToShootingPlayer = false;
                PenaltyManager.shootPenalty();
            }
        }

        public static onGoal(): void {

            GameVars.gameData.statsData.scoredPenalties ++;
            
            GameVars.penaltyScored = true;
            GameVars.matchResult = GameConstants.VICTORY;

            GameManager.onMatchEnded();
        }

        public static onMatchStart(): void {

            PenaltyFootballFieldState.currentInstance.onMatchStart();

            PenaltyManager.game.time.events.add( 150 , function (): void {
                GameVars.paused = false;
            }, this);
        }

        public static onBallOutsideFootballField(): void {
  
            GameVars.penaltyScored = false;
            GameVars.matchResult = GameConstants.DRAW;

            GameManager.onMatchEnded();
        }

        private static shootPenalty(): void {

            PenaltyManager.forward.hasReceived = false;
            PenaltyManager.forward.shootBall();
            // para que no la pueda pillar de nuevo y se quede como mero cuerpo de fisicas
            PenaltyManager.forward.name = GameConstants.FORWARD_PEG_PENALTY;
            PenaltyManager.forward.ball.destroy();

            const px = this.forward.x;
            const py = this.forward.y;

            const angle = this.forward.getShootAngle();

            const ball_px = px + 75 * Math.cos( angle * Math.PI / 180 );
            const ball_py = py + 75 * Math.sin( angle * Math.PI / 180 );

            PenaltyFootballFieldState.currentInstance.shootPenalty( ball_px , ball_py , angle );
        }
    }
